import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  Slide,
} from "@mui/material";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import { useAppSelector } from "../../../../../reduxStore/hooks";
import { RootState } from "../../../../../reduxStore/store";
import { AdminDialogSeverity } from "../../../../../reduxStore/features/adminDialogSlice";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AdminDialog = () => {
  const { adminDialogMessage, openAdminDialog, severity } = useAppSelector(
    (state: RootState) => state.adminDialog
  );

  //   const handleClose = useCallback(()=>{
  //     dispatch(handleCloseDialog())
  //   },[dispatch,openAdminDialog])

  const severityFontColor =
    severity === AdminDialogSeverity.ERROR
      ? "indianred"
      : severity === AdminDialogSeverity.SUCCESS
      ? "green"
      : severity === AdminDialogSeverity.WARNING
      ? "orange"
      : "inherit";

  return (
    <Dialog
      open={openAdminDialog}
      TransitionComponent={Transition}
      keepMounted
      //   onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      disableEscapeKeyDown
    >
      <DialogTitle>{"Admin activity in progress"}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: 1,
          }}
        >
          <GppMaybeIcon sx={{ fontSize: "5rem", color: severityFontColor }} />
          <LinearProgress
            color={
              severity === AdminDialogSeverity.ERROR
                ? "error"
                : severity === AdminDialogSeverity.SUCCESS
                ? "success"
                : severity === AdminDialogSeverity.WARNING
                ? "warning"
                : "secondary"
            }
            sx={{ width: "100%" }}
          />
        </Box>
        <DialogContentText
          id="alert-dialog-slide-description"
          sx={{
            color: severityFontColor,
            textAlign: "center",
          }}
        >
          {adminDialogMessage || "Please Wait..."}
        </DialogContentText>
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={handleClose}>Disagree</Button>
        <Button onClick={handleClose}>Agree</Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default AdminDialog;